import { useMutation } from "@apollo/client";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ARCHIVE_PROJECT } from "../../../../GraphQL/settings/mutations";
import { EToastPosition, EToastColorStatus } from "../../../../interfaces";

interface IArchiveModalProps {
  showArchiveModal: boolean;
  onCloseModal: () => void;
  projectId: number|null;
  reloadProjects: () => void;
  onHandleCreateToast: (
    color    : EToastColorStatus,
    position : EToastPosition,
    message  : string,
  ) => void;
}

const ArchiveProjectModal = ({
  showArchiveModal,
  onCloseModal,
  projectId,
  reloadProjects,
  onHandleCreateToast = () => {},
}: IArchiveModalProps) => {
  const [archiveProject] = useMutation(ARCHIVE_PROJECT, {
    onCompleted() {
      onCloseModal();
      onHandleCreateToast(
        EToastColorStatus.SUCCESS,
        EToastPosition.BOTTOM_END,
        "Archived project successfully",
      );
      reloadProjects();
    },
    onError() {
      onHandleCreateToast(
        EToastColorStatus.FAILED,
        EToastPosition.BOTTOM_END,
        "Error, something went wrong",
      );
    },
  });

  const handleArchiveProject = () => {
    if (projectId) {
      archiveProject({variables: { projectId }});
    }
  }

  return (
    <Dialog open={showArchiveModal} onOpenChange={onCloseModal}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Archive Project</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          Do you want to archive this project?
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={onCloseModal}>
            Close
          </Button>
          <Button variant="destructive" onClick={handleArchiveProject}>
            Archive
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ArchiveProjectModal;
